import { useContext, useEffect, useMemo, useState } from 'react';
import Steps from './components/Steps/Steps';
import css from './StoreRegister.module.scss';
import { getSteps } from './helpers';
import RegisterView from './components/RegisterView/RegisterView';
import AccountActivation from './components/AccountActivation/AccountActivation';
// import Order from './components/Order/Order';
import OrderNew from './components/Order/OrderNew';
import UserContext from '../../common/utils/getContext';
import classNames from 'classnames';
import { svgSprite, zendoStorage } from '../../hybrid/wrappers';
import T from '../../common/components/T';
import { useRouter } from 'next/router';
import { navigateV2 } from '../../common/utils/router';

const StoreRegister = () => {
    const { setState } = useContext(UserContext);
    const [activeStep, setActiveStep] = useState(0);
    const steps = useMemo(() => getSteps(), []);

    const [formData, setFormData] = useState({});
    const [userData, setUserData] = useState({});
    const [initValue, setInitValue] = useState();

    // юзер, якого зареєстровують з кабінету
    const [partner, setPartner] = useState('');

    const router = useRouter();

    const isOfficeRegister = useMemo(() => router?.query?.o === '1', [router]);

    useEffect(() => {
        if (isOfficeRegister) zendoStorage.set('isOfficeRegister', true, true);
    }, [isOfficeRegister]);

    const viewComponent = useMemo(() => {
        switch (activeStep) {
            case 0: {
                return (
                    <RegisterView
                        setPartner={setPartner}
                        setActiveStep={setActiveStep}
                        isOfficeRegister={isOfficeRegister}
                        setUserData={setUserData}
                        initValue={initValue}
                        setInitValue={setInitValue}
                    />
                );
            }
            case 1: {
                return (
                    <AccountActivation
                        formData={formData}
                        setFormData={setFormData}
                        setActiveStep={setActiveStep}
                        partner={partner}
                        userData={userData}
                        initValue={initValue}
                        isOfficeRegister={isOfficeRegister}
                    />
                );
            }
            // case 2: {
            //     return <OrderNew formData={formData} setFormData={setFormData} setActiveStep={setActiveStep} />
            // }
            default:
                return null;
        }
    }, [initValue, activeStep, formData, isOfficeRegister]);

    useEffect(() => {
        setState('showRegWindow', false);
    }, []);

    return (
        <div className={css.container}>
            <div className={css.titleBlock}>
                <div className={css.titleBlockContent}>
                    <div
                        onClick={() => {
                            const prevURL = JSON.parse(zendoStorage.get('prevUrlData'));
                            if (prevURL?.route === '/auth/register') navigateV2('/');
                            else router.back();
                        }}
                        className={classNames('circleButton', 'grow', css.backBtn)}
                    >
                        {svgSprite('arrow-left')}
                    </div>
                    <p className={css.titleBlockText}>
                        <T textName='user-register' defaultStr='Регистрация пользователя' />
                    </p>
                </div>
            </div>
            <div className={css.wrapper}>
                <div className={css.content}>
                    <Steps steps={steps} activeStep={activeStep}>
                        {viewComponent}

                        <OrderNew
                            activeStep={activeStep}
                            userData={userData}
                            setFormData={setFormData}
                            setActiveStep={setActiveStep}
                            partner={partner}
                            initValue={initValue}
                        />
                    </Steps>
                </div>
            </div>
        </div>
    );
};

export default StoreRegister;
